<template>
    <transition name="fade">
        <div
            v-if="loading && show"
            class="position-absolute w-100 h-100 top-0"
        >
            <div class="d-table text-center w-100 h-100">
                <div class="d-table-cell align-middle">
                    <i class="fa fa-spin fa-circle-notch fa-3x" />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "BaseTableLoader",

        props: {
            loading: Boolean,
        },

        data: function () {
            return {
                show: false,
            }
        },

        watch: {
            loading: function () {
                this.show = false
                // retarde l'affichage du loader de 200ms pour ne l'afficher que si l'application met du temps à répondre
                setTimeout(() => this.show = true, 200)
            }
        },
    }
</script>
